import { render, staticRenderFns } from "./Zktich.vue?vue&type=template&id=0a3889bb&scoped=true&"
import script from "./Zktich.vue?vue&type=script&lang=ts&"
export * from "./Zktich.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3889bb",
  null
  
)

export default component.exports